var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('K2Text',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"d-block K2Input"},[_c('input',_vm._g({attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value}},_vm.listeners))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }